var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4998 2.42619L3.93846 3.93846L2.42619 11.4998C2.40197 11.6209 2.40802 11.7461 2.4438 11.8642C2.47958 11.9824 2.54398 12.0899 2.63129 12.1772L12.4237 21.9697C12.4934 22.0393 12.5761 22.0946 12.6671 22.1323C12.7581 22.17 12.8556 22.1894 12.9541 22.1894C13.0526 22.1894 13.1501 22.17 13.2411 22.1323C13.3321 22.0946 13.4148 22.0393 13.4844 21.9697L21.9697 13.4844C22.0393 13.4148 22.0946 13.3321 22.1323 13.2411C22.17 13.1501 22.1894 13.0526 22.1894 12.9541C22.1894 12.8556 22.17 12.7581 22.1323 12.6671C22.0946 12.5761 22.0393 12.4934 21.9697 12.4237L12.1772 2.63129C12.0899 2.54398 11.9824 2.47958 11.8642 2.4438C11.7461 2.40802 11.6209 2.40197 11.4998 2.42619V2.42619Z",
    stroke: "#262D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 9C8.49632 9 9 8.49632 9 7.875C9 7.25368 8.49632 6.75 7.875 6.75C7.25368 6.75 6.75 7.25368 6.75 7.875C6.75 8.49632 7.25368 9 7.875 9Z",
    fill: "#262D38"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/Categories.75b9490ff625b5408052551375297d90.svg";
export { ForwardRef as ReactComponent };